export enum KpiMetricTableType {
  WORKFLOW = 'Workflow',
  ACCEPTANCE = 'Acceptance',
  PERFORMANCE = 'Performance',
}
